<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title="Home"
        @back="$router.push({ name: 'plp.external'})"
        :content="$t('registrar-plp-externa')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
      >
        <el-form-item :label="$t('cliente')" prop="customer" v-if="userType !== '2' && userType !== '5'">
          <CustomerList
            v-model="ruleForm.customer"
            v-bind:customerType="1"
            v-bind:current="ruleForm.customer"
          />
        </el-form-item>
        <el-form-item :label="$t('selecione-terceiro')" prop="external">
          <ExternalList :userType="userType" v-on:selected="external" />
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="8" :md="8" :lg="3" :xl="3">
            <el-form-item :label="$t('plp')" prop="plp">
              <el-input
                :placeholder="$t('plp')"
                v-model="ruleForm.plp"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item :label="$t('etiqueta')" prop="tag">
              <el-input
                :placeholder="$t('etiqueta')"
                v-on:keyup.native.enter="add()" 
                v-model="ruleForm.tag"
              >
                <el-button
                  slot="append"
                  icon="el-icon-check"
                  @click="search"
                  >{{ $t("validar") }}
                </el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :data="tableData"
        ref="tableTags"
        stripe
        :default-sort="{ prop: 'tag', order: 'ascending' }"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column
          sortable
          prop="tag"
          :label="$t('etiqueta')"
        />
        <el-table-column
          sortable
          prop="service"
          :label="$t('servico')"
        />
        <el-table-column
          sortable
          prop="zipcode"
          :label="$t('cep')"
        />
      </el-table>
      <div class="bottom clearfix">
        <el-button icon="el-icon-check" :disabled="!plpResult" type="success" @click="save">Registrar</el-button>
      </div>      
    </el-card>

  </div>
</template>

<script>
import { ExternalService } from "@/services/customers/external.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ExternalPostList from "../../dashboard/prepost/components/ExternalPostList.vue";
import ExternalList from "./ExternalList.vue";

export default {
  name: "PlpExternalRegister",
  components: {
    CustomerList,
    ExternalList,
    ExternalPostList
},
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  methods: {
    external(value) {
      const vm = this;
      vm.ruleForm.external = value;
    },
    search() {
      const vm = this;
      if (!vm.ruleForm.plp || !vm.ruleForm.tag) {
        this.$message({ type: "error", message: "É preciso informar a PLP e o Objeto/Rastreio para realizar a pesquisa!" });
      }
      vm.plpResult = null;
      vm.tableData = [];
      const loading = vm.$loading(vm.$options.loading);
      ExternalService.plp(vm.ruleForm.plp, vm.ruleForm.tag)
        .then((response) => {
          if (response.status !== 200) {
            return this.$message({ type: "error", message: response.message });
          }
          vm.plpResult = response.data;
          if (vm.plpResult && vm.plpResult.tags) {
            vm.tableData = vm.plpResult.tags;
            this.$refs.tableTags.toggleAllSelection()
          }
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
    save() {
      const vm = this;
      if (!vm.plpResult) {
        return this.$message({ type: "error", message: "É preciso validar uma PLP antes de realizar o registro!" });
      }
      if (vm.userType !== '2' && vm.userType !== '5' && !vm.ruleForm.customer) {
        return this.$message({ type: "error", message: "É preciso informar um cliente para realizar o registro!" });
      }
      if (!vm.ruleForm.external) {
        return this.$message({ type: "error", message: "É preciso selecionar um terceiro para realizar o registro!" });
      }
      if (vm.$refs.tableTags.selection.length === 0) {
        return this.$message({
          type: "error",
          message: "É preciso selecionar ao menos uma etiqueta apra registro!",
          duration: 5000,
        });
      }
      const loading = vm.$loading(vm.$options.loading);
      
      ExternalService.register(vm.ruleForm, vm.$refs.tableTags.selection.map(x => {
        return x.tag;
      })).then(() => {
          vm.tableData = [];
          vm.ruleForm.plp = "";
          vm.ruleForm.tag = "";
          vm.plpResult = null;
          this.$message({
            type: "success",
            message: "PLP de terceiro registrada com sucesso!",
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  data() {
    return {
      tag: "",
      userType: "2",
      loading: false,
      plpResult: null,
      tableData: [],
      ruleForm: {
        customer: "",
        plp: "",
        tag: "",
        external: "",
      }
    };
  },
};
</script>
